import React, { useEffect, useState } from "react";
import { Survey } from "./survey-types";
import { useOutletContext } from "react-router-dom";
import { SurveyResultsTiles } from "./results/SurveyResultsTiles";
import { SurveyResults } from "@/features/survey-results/survey-results-types";
import { randomAnsweringService } from "./mock/RandomAnsweringService";
import { answerSurveyLLM } from "@/server/AnsweringService";
import LoadingOverlay from "@/components/LoadingOverlay";
import AlertModal from "@/components/AlertModal";
import { storageService } from "@/services/StorageService";

const SurveyResultsTab: React.FC = () => {
  const { survey, results, updateResults } = useOutletContext<{
    results: SurveyResults | undefined;
    survey: Survey | undefined;
    updateResults: (results: SurveyResults) => void;
  }>();
  const [loading, setLoading] = useState(false);
  const [isAlertModalOpen, setIsAlertModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  //const [results, setResults] = useState<SurveyResults | undefined>(undefined);

  useEffect(() => {
    if (!survey) {
      return;
    }
    console.info("Fetching results for survey", survey);
    storageService.getResultsBySurveyId(survey.id).then((results) => {
      console.info("Set Results", results);
      results && updateResults(results);
    });
  }, [survey]);

  async function handleAnswerSurveyRandom() {
    const results = await randomAnsweringService.answerSurvey(survey!);
    console.info("Answered survey (random)", results);
    updateResults(results);
  }

  async function handleAnswerSurveyLLM() {
    setLoading(true);
    try {
      console.info("Answering survey");
      const results = await answerSurveyLLM(survey!);
      console.info("Answered survey (LLM)", results);
      updateResults(results);
      storageService.saveSurveyResults(results);
    } catch (error) {
      console.error("Error fetching data:", error);
      const errorMessage =
        (error instanceof Error ? error.message : String(error)) ||
        "Something went wrong. Check the console for more details.";
      setErrorMessage(errorMessage);
      setIsAlertModalOpen(true);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="flex flex-col gap-4">
      {loading && <LoadingOverlay message="Answering survey..." />}
      {results && survey ? (
        <SurveyResultsTiles results={results} survey={survey} />
      ) : (
        <p className="mb-8">No results for this survey</p>
      )}
      <button className="btn-primary" onClick={handleAnswerSurveyLLM}>
        Answer Survey (LLM)
      </button>
      <button className="btn-primary" onClick={handleAnswerSurveyRandom}>
        Answer Survey (random, not LLM-based)
      </button>

      <AlertModal
        isOpen={isAlertModalOpen}
        title="Error"
        message={errorMessage}
        onClose={() => setIsAlertModalOpen(false)}
      />
    </div>
  );
};

export default SurveyResultsTab;
